import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../Basic/Buttons/Button';
import Icon from '../../Basic/Elements/Icon';
import profile from '../../../assets/media/icons/profile.svg';
import Text from '../../Basic/WrapsStyle/Text';

const ProfileIcon = ({ ...props }) => {
    let navigate = useNavigate();
    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();

    const { auth } = user;

    return (
        auth && (
            <Button
                style={{ marginRight: '30px' }}
                onClick={() => navigate('/user/profile', { replace: true })}
            >
                <Text style={{ width: 'max-content' }}> {user.name}</Text>
                <Icon src={user.avatar || profile} width={'30px'} style={{ marginLeft: '15px', borderRadius: '50%' }} />
            </Button>
        )
    );
};

export default ProfileIcon;
